"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Datadownload = function Datadownload(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "DatadownloadTitle DatadownloadDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "DatadownloadTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "DatadownloadDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M9.105 16.43l2.285 2.285V7.645a.6.6 0 0 1 .186-.44.6.6 0 0 1 .44-.185.617.617 0 0 1 .625.625v11.03l2.265-2.245a.567.567 0 0 1 .44-.196c.175 0 .322.065.439.196.13.117.195.26.195.43a.615.615 0 0 1-.195.448L11.995 21l-3.788-3.692a.89.89 0 0 1-.127-.214.605.605 0 0 1-.049-.235c0-.078.016-.156.049-.234a.597.597 0 0 1 .127-.195c.13-.13.28-.196.449-.196.17 0 .319.065.45.196zM2 4.163c0-.327.12-.603.361-.827.241-.224.537-.336.889-.336h17.5c.352 0 .648.112.889.336.24.224.361.5.361.827v7.674c0 .315-.12.588-.361.818-.241.23-.537.345-.889.345h-5.645v-1.181h4.883a.78.78 0 0 0 .537-.2.632.632 0 0 0 .225-.49V4.87a.66.66 0 0 0-.225-.5.761.761 0 0 0-.537-.208L4.012 4.18a.761.761 0 0 0-.537.209.66.66 0 0 0-.225.5v6.239a.63.63 0 0 0 .225.49c.15.133.328.2.537.2h4.863V13H3.25c-.352 0-.648-.115-.889-.345A1.094 1.094 0 0 1 2 11.837V4.163z",
    id: "refDatadownloadZwGTH3smaW9"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refDatadownloadZwGTH3smaW9",
    fillRule: "evenodd"
  }));
};

Datadownload.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Datadownload.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Datadownload;
exports["default"] = _default;